<app-navbar></app-navbar>
<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-samplecenter-sidebar></app-samplecenter-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div
              class="card shadow custom-margin-right-box"
              style="width: 100%"
            >
              <div class="card-header">
                <h4>My Profile</h4>
              </div>
              <div class="card-body">
                <div class="container">
                  <div class="row">
                    <div class="col-lg-3">
                      <img
                        [src]="profile_image"
                        class="img-fluid profile-pic"
                        alt="avatar"
                        style="height: 175px; width: 100%;"
                      />

                      <p class="profile-name-box">{{ profile_name }}</p>
                    </div>

                    <div class="col-lg-9">
                      <div class="d-flex justify-content-center">
                        <form
                          [formGroup]="updateProfileForm"
                          (ngSubmit)="onSubmit(updateProfileForm.value)"
                        >
                          <div class="row">
                            <div class="col-md-6 mt-1">
                              <label class="form-label"
                                >Name<sup
                                  class="ml-1 font-weight-bolder text-danger"
                                  >*</sup
                                ></label
                              >
                              <input
                                type="text"
                                class="form-control"
                                formControlName="name"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; updateProfileForm.controls.name.errors }"
                                placeholder="Name e.g John Doe"
                                maxlength="25"
                              />
                              <div
                                *ngIf="submitted &amp;&amp; updateProfileForm.controls.name.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    updateProfileForm.controls.name.errors
                                      .required
                                  "
                                >
                                  Name is required
                                </div>
                                <div
                                  *ngIf="
                                    updateProfileForm.controls.name.errors
                                      .whitespace
                                  "
                                >
                                  Please enter valid data
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 mt-1">
                              <label class="form-label"
                                >Email Address<sup
                                  class="ml-1 font-weight-bolder text-danger"
                                  >*</sup
                                ></label
                              >
                              <input
                                type="email"
                                class="form-control"
                                formControlName="emailAddress"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; updateProfileForm.controls.emailAddress.errors }"
                                placeholder="Email Address e.g example@example.com"
                                disabled
                              />
                              <div
                                *ngIf="submitted &amp;&amp; updateProfileForm.controls.emailAddress.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    updateProfileForm.controls.emailAddress
                                      .errors.required
                                  "
                                >
                                  Email is required
                                </div>
                                <div
                                  *ngIf="
                                    updateProfileForm.controls.emailAddress
                                      .errors.pattern
                                  "
                                >
                                  Please enter a valid email
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 mt-3">
                              <label class="form-label"
                                >Role Name<sup
                                  class="ml-1 font-weight-bolder text-danger"
                                ></sup
                              ></label>

                              <select
                                class="form-control"
                                formControlName="roleName"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; updateProfileForm.controls.roleName.errors }"
                                disabled
                              >
                                <option value="">Select Role</option>
                                <option
                                  *ngFor="let role of roles"
                                  [value]="role.id"
                                >
                                  {{ role.display_name }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-6 mt-3">
                              <label class="form-label"
                                >Phone Number<sup
                                  class="ml-1 font-weight-bolder text-danger"
                                  >*</sup
                                ></label
                              >
                              <input
                                type="text"
                                class="form-control"
                                formControlName="phoneNumber"
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; updateProfileForm.controls.phoneNumber.errors }"
                                placeholder="Phone Number e.g 08065431765"
                                maxlength="11"
                              />
                              <div
                                *ngIf="submitted &amp;&amp; updateProfileForm.controls.phoneNumber.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    updateProfileForm.controls.phoneNumber
                                      .errors.required
                                  "
                                >
                                  Phone Number is required
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6 mt-3">
                              <label class="form-label"
                                >Profile Image<sup
                                  class="ml-1 font-weight-bolder text-danger"
                                  >*</sup
                                ></label
                              >
                              <input
                                type="file"
                                (change)="onFileChange($event)"
                                accept="image/jpeg, image/jpg, image/png"
                                class="form-control"
                                placeholder=""
                                [ngClass]="{ 'is-invalid': submitted &amp;&amp; updateProfileForm.controls.profileImage.errors }"
                                style="padding: 3px 3px !important"
                              />
                              <!-- Preview Image Upload -->
                              <img
                                *ngIf="imagePreviewSrc"
                                [src]="imagePreviewSrc"
                                width="100"
                                height="100"
                                class="mt-4"
                              />

                              <div
                                *ngIf="submitted &amp;&amp; updateProfileForm.controls.profileImage.errors"
                                class="form-text text-danger"
                              >
                                <div
                                  *ngIf="
                                    updateProfileForm.controls.profileImage
                                      .errors.required
                                  "
                                >
                                  Profile image is required
                                </div>
                              </div>
                            </div>

                            <div class="col-md-12 mt-5 text-right">
                              <button
                                type="submit"
                                class="
                                  btn btn-secondary
                                  theme-btn-2
                                  dropdown-toggle-no
                                "
                              >
                                Update Details
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer-dashboard></app-footer-dashboard>
